/**
 * VCDR Backend Public APIs
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface AWSSecrets { 
    secret_name: string;
    created_date?: Date;
    last_accessed_date?: Date;
}

